import { useState, useEffect } from "react";
import { Row, Col, Tag } from "antd";
import dayjs from "dayjs";

import DataTable from "../../DataTable";
import AuditModal from "../../ModalForm/Member/AuditModal";

interface IAuditProps {
  audits: any;
}

const ClaimAuditTable: React.FC<IAuditProps> = ({ audits }) => {
  const [all, setAll] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    pageSize: 15,
    position: ["bottomRight"],
    total: 0,
    current: 1,
    hideOnSinglePage: true,
  });
  const [show, setShow] = useState(false);
  const [content, setContent] = useState<string>("");

  const showModal = (record: any) => {
    setShow(!show);
    setContent(record);
  };

  useEffect(() => {
    if (audits) {
      setAll(audits);
      setPagination((prev) => ({
        ...prev,
        total: audits.length,
      }));
      setLoading(false);
    }
  }, [audits]);

  const handleTableChange = (pagination: any) => {
    setPagination(pagination);
  };

  // Get color for action tag
  const getActionColor = (action: string) => {
    const actionLower = action?.toLowerCase() || "";

    if (actionLower.includes("pending"))
      return "blue";
    if (actionLower.includes("approved"))
      return "green";
    if (actionLower.includes("rejected"))
      return "red";
    if (actionLower.includes("paid"))
      return "orange";
    if (actionLower.includes("closed"))
      return "purple";
    return "default";
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "Date",
      render: (date: Date) => dayjs(date).format("YYYY-MM-DD"),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (action: string) => (
        <Tag color={getActionColor(action)}>{action}</Tag>
      ),
    },
    {
      title: "User",
      dataIndex: ["User", "Name"],
    },
    {
      title: "Reason",
      dataIndex: "Reason",
    },
    {
      title: "Notes",
      dataIndex: "Notes",
    },
  ];

  return (
    <>
      <Row>
        <Col span={24}>
          <DataTable
            persistKey="claim-audit"
            dataSource={all}
            columns={columns}
            loading={loading}
            pagination={pagination}
            onChange={handleTableChange}
          />
        </Col>

        <AuditModal show={show} showModal={showModal} content={content} />
      </Row>
    </>
  );
};

export default ClaimAuditTable;
